import { Uuid } from "../../../../domain/model/uuid/uuid.type";
import { DataStoreId } from "../../data-store-id.type";

export class StoreGroup implements DataStoreId {
  readonly id: string;
  readonly name: string;
  readonly number: number;

  constructor(id: Uuid, name: string, number: number) {
    this.id = id.asString();
    this.name = name;
    this.number = number;
  }
}
